import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d24d72d4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24d72d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d24d72d4')) {
      api.createRecord('d24d72d4', component.options)
    } else {
      api.reload('d24d72d4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d24d72d4&scoped=true", function () {
      api.rerender('d24d72d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/biPanel/index.vue"
export default component.exports